import { useEffect, useCallback } from 'react';
import { useRoutes } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { setActivePermissions } from './store/dictionaries/slices';
import {
  useLazyGetExchangePermissionsQuery,
  useLazyGetExchangeWhitelabelQuery,
} from './store/dictionaries/services';
import Exchange from './hoc/exchange/exchange';
import MarginsRoutes from './routes/margins';
import RatesRoutes from './routes/rates';
import AutoSettingsRoutes from './routes/auto-settings';
import RateRequestRoutes from './routes/rate-request';
import ROUTES from './routes';

export const routes = {
  path: ROUTES.EXCHANGE,
  element: <Exchange />,
  children: [
    { ...MarginsRoutes },
    { ...RatesRoutes },
    { ...AutoSettingsRoutes },
    { ...RateRequestRoutes },
  ],
};

const ExchangeRoutes = () => {
  const elements = useRoutes([{ ...routes }]);

  const dispatch = useAppDispatch();

  const { activePermissions, whitelabel } = useAppSelector(
    (state) => state.exchangeDictionaries,
  );

  const [getExchangePermissions] = useLazyGetExchangePermissionsQuery();
  const [getExchangeWhiteLabel] = useLazyGetExchangeWhitelabelQuery();

  const getExchangePermissionsAction = useCallback(() => {
    getExchangePermissions();
  }, []);

  const permissions = JSON.parse(
    localStorage.getItem('activePermissions') as string,
  );

  useEffect(() => {
    const companyName = localStorage.getItem('companyName');

    if (!companyName) {
      getExchangeWhiteLabel();
    }
  }, []);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  useEffect(() => {
    if (permissions && !activePermissions) {
      dispatch(setActivePermissions(permissions));
    } else if (!permissions && !activePermissions) {
      getExchangePermissionsAction();
    }
  }, [permissions, getExchangePermissionsAction, dispatch, activePermissions]);

  return elements;
};

export default ExchangeRoutes;
